import { connect } from 'react-redux'
import EditOrganization from '../../components/organizations/edit/EditOrganizationPane'
import {
  updateOrganization,
  createOrganizationBankAccount,
  createOrganizationLegalEntity,
  createOrgClear,
  removeOrganizationBankAccount,
  setOrganizationDefaultBankAccount,
  getOrganizationLegalEntity,
  getSingleOrganization,
  updateOrganizationLegalEntity,
  clearOrganizationLegalEntity,
  createOrgSubscription,
  updateOrgSubscription
} from '../../state/actions/organizations'
import { actionCreators } from '../../state/actions/organizations'
import {
  getOrganizationProcessing,
  getOrganizationProcessingError,
  getOrganization
} from '../../state/reducers/organizations'
import {
  ICreateBankAccountObj,
  ILegalEntityObj,
  IStoreState,
  IOrgObj,
  ICreateOrgSubscriptionDTO,
  IUpdateOrgSubscriptionDTO
} from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  const orgId = ownProps.match.params.id
  return {
    organization: getOrganization(state, orgId),
    legalEntity: state.organizationLegalEntity.entity,
    bankAccounts: state.organizationsBankAccounts.items,
    orgId,
    metadata: state.organizations.metadata,
    creating: getOrganizationProcessing(state),
    error: getOrganizationProcessingError(state),
    routeProps: ownProps
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    createOrg: (data: IOrgObj) => dispatch(updateOrganization(data)),
    updateOrg: (data: IOrgObj) => dispatch(updateOrganization(data)),
    createOrgClear: () => {
      dispatch(createOrgClear())
      dispatch(clearOrganizationLegalEntity())
    },
    fetchOrg: (orgId: string) => dispatch(getSingleOrganization(orgId)),
    getOrganizationLegalEntity: (orgId: string) => dispatch(getOrganizationLegalEntity(orgId)),
    updateOrganizationLegalEntity: (data: ILegalEntityObj, orgId: string) =>
      dispatch(updateOrganizationLegalEntity(data, orgId)),
    createOrganizationBankAccount: (data: ICreateBankAccountObj, orgId: string) => {
      return new Promise((approve, reject) => {
        dispatch(createOrganizationBankAccount(data, orgId)).then(() => {
          dispatch(getOrganizationLegalEntity(orgId)).then(() => {
            approve()
          })
        })
      })
    },
    createOrganizationLegalEntity: (data: ILegalEntityObj, orgId: string) =>
      dispatch(createOrganizationLegalEntity(data, orgId)),
    removeOrganizationBankAccount: (orgId: string, bankAccountId: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeOrganizationBankAccount(orgId, bankAccountId)).then(() => {
          dispatch(getOrganizationLegalEntity(orgId)).then(() => {
            approve()
          })
        })
      })
    },
    createOrgSubscription: (dto: ICreateOrgSubscriptionDTO) => dispatch(createOrgSubscription(dto)),
    updateOrgSubscription: (dto: IUpdateOrgSubscriptionDTO) => dispatch(updateOrgSubscription(dto)),
    setOrganizationDefaultBankAccount: (orgId: string, bankAccountId: string) =>
      dispatch(setOrganizationDefaultBankAccount(orgId, bankAccountId)),
    resetOrgMetadata: () => dispatch(actionCreators.resetOrgMetadata())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditOrganization)



// WEBPACK FOOTER //
// ./src/containers/organizations/EditOrganizationPane.ts